export default function KeyFigures() {
  const stats = [{
    value: "13%",
    label: "Ontario HST Rate"
  }, {
    value: "2.1%",
    label: "2026 Rent Cap"
  }, {
    value: "$7,000",
    label: "2026 TFSA Limit"
  }];
  return <section data-section-id="223330" id="by-the-numbers" className="bg-slate-950 text-white py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-3 sm:gap-8">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center sm:items-start sm:text-left">
              <span className="font-mono text-5xl font-bold text-primary">
                {stat.value}
              </span>
              <span className="font-default text-slate-400 mt-2 text-xs uppercase tracking-widest">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}